'use client';

import { c as _c } from "react/compiler-runtime";
import { ReactNode } from 'react';
import classnames from 'classnames';
import type { Organization } from '@personly/libs-types';
import Picture from '@/components/picture';
import { makeFileSrcSets } from '@/libs/srcSets';
const className = classnames('flex', 'flex-row', 'p-2', 'bg-card-inset-background-color', 'text-sm', 'rounded', 'text-card-subtitle-color');
interface Props {
  children: ReactNode;
  organization: Organization;
}
const PersonalOrganization = t0 => {
  const $ = _c(7);
  const {
    children,
    organization
  } = t0;
  const {
    fileSources
  } = organization;
  let t1;
  if ($[0] !== fileSources) {
    t1 = Object.keys(fileSources).length > 0 && <div className="flex pr-2 justify-center items-center w-2/5"><Picture srcSets={makeFileSrcSets(fileSources)} className="h-auto w-full" sizes="100vw" /></div>;
    $[0] = fileSources;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children) {
    t2 = <div>{children}</div>;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className={className}>{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default PersonalOrganization;